import * as XLSX from 'xlsx';

export const TEMPLATE_COLUMNS = [
  'EnquiryId',
  'StudentCode',
  'BatchCode',
  'UserName',
  'Password',
] as const;

export type TemplateColumnName = (typeof TEMPLATE_COLUMNS)[number];

export const REQUIRED_COLUMNS: TemplateColumnName[] = [
  'EnquiryId',
  'StudentCode',
  'BatchCode',
];

/** Columns that support AUTO value (system will auto-generate) */
export const AUTO_COLUMNS: TemplateColumnName[] = [
  'StudentCode',
  'UserName',
  'Password',
];

/**
 * Columns that additionally support the STUDENTCODE keyword — when present,
 * the field is set to the resolved StudentCode for that row instead of being
 * randomly auto-generated.
 */
export const STUDENTCODE_COLUMNS: TemplateColumnName[] = [
  'UserName',
  'Password',
];

/** Set of accepted "magic" keywords (case-insensitive). */
export const KEYWORDS = ['AUTO', 'STUDENTCODE'] as const;

export function generateStudentTemplate(): void {
  const wb = XLSX.utils.book_new();

  const templateData = [
    [...TEMPLATE_COLUMNS],
    [1, 'STU001', 'BATCH-A', 'STU001', 'STU001'],
    [2, 'AUTO', 'BATCH-B', 'AUTO', 'AUTO'],
    [3, 'AUTO', 'BATCH-B', 'STUDENTCODE', 'STUDENTCODE'],
  ];

  const sheet = XLSX.utils.aoa_to_sheet(templateData);
  sheet['!cols'] = [
    { wch: 12 },
    { wch: 16 },
    { wch: 14 },
    { wch: 16 },
    { wch: 14 },
  ];
  XLSX.utils.book_append_sheet(wb, sheet, 'Students');

  const instructionsData = [
    ['Column', 'Required', 'Description', 'Example'],
    ['EnquiryId', 'Yes', 'Enquiry ID of the student', '1'],
    ['StudentCode', 'Yes', 'Unique student code. Use AUTO to generate from the batch series.', 'STU001 or AUTO'],
    ['BatchCode', 'Yes', 'Batch code to enroll the student in', 'BATCH-A'],
    ['UserName', 'No', 'Login username. AUTO or STUDENTCODE both mirror the resolved StudentCode.', 'STU001 / AUTO / STUDENTCODE'],
    ['Password', 'No', 'Login password. AUTO generates a random 8-char password; STUDENTCODE sets it to the resolved StudentCode.', 'STU001 / AUTO / STUDENTCODE'],
  ];
  const instrSheet = XLSX.utils.aoa_to_sheet(instructionsData);
  instrSheet['!cols'] = [{ wch: 16 }, { wch: 10 }, { wch: 55 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, instrSheet, 'Instructions');

  XLSX.writeFile(wb, 'student-enrollment-template.xlsx');
}
